export enum ProcessTypeEnum {
  CUSTOM = '5'
}

export const ProcessTypeLabels: { [key: string]: string } = {
  [ProcessTypeEnum.CUSTOM]: 'Custom'
};

export function getProcessTypeLabel(processTypeId: string): string {
  return ProcessTypeLabels[processTypeId] || `Process Type ${processTypeId}`;
}
